export default {
  SET_REVENUE (state, revenue) {
    state.revenue = revenue
  },
  REMOVE_RECORD (state, itemId) {
    const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.users.splice(userIndex, 1)
  }
}
